import React from 'react'
import { Lexicon } from '@nitidbit/lexicon'
import SearchCheckbox from '../../search/SearchCheckbox/SearchCheckbox.jsx'
import SearchInputField from '../../search/SearchInputField/SearchInputField.jsx'
import SearchForm from '../../search/SearchForm/SearchForm.jsx'
import SearchFormBar from '../../search/SearchForm/SearchFormBar.jsx'
import SearchSubmitButton from '../../search/SearchSubmitButton/SearchSubmitButton.jsx'
import SearchFormCondensed from '../../search/SearchFormCondensed/SearchFormCondensed.jsx'
import './ClinicFinderForm.scss'
import locationIcon from './location_icon.svg'
import lexiconRaw from '../ClinicFinderStrings.json'

const locale = document.documentElement.lang || 'en'
const lexicon = new Lexicon(
  lexiconRaw,
  locale,
  'bedsider/app/javascript/components/search/ClinicFinder/ClinicFinderStrings.json'
)
const clinicFinderLexicon = lexicon.subset('ClinicFinderForm')

const ClinicFinderForm = ({
  searchTerms,
  updateSearchTerms,
  onSearch,
  isCondensed = false,
  setIsCondensed = () => {},
  showTitle = true,
}) => {
  const forceStacked = false
  const isSearchSubmitDisabled = searchTerms.location.trim().length === 0
  return (
    <div className={`ClinicFinderForm ${isCondensed ? 'condensed' : ''}`}>
      {isCondensed ? (
        <SearchFormCondensed
          searchValues={[searchTerms.location]}
          onEdit={() => setIsCondensed(false)}
          lexicon={clinicFinderLexicon}
        />
      ) : (
        <SearchForm
          title={showTitle ? clinicFinderLexicon.get('header') : ''}
          forceStacked={forceStacked}
        >
          <SearchFormBar forceStacked={forceStacked}>
            <SearchInputField
              value={searchTerms.location}
              setValue={(value) => updateSearchTerms({ location: value })}
              label={clinicFinderLexicon.get('location_label')}
              placeholder={clinicFinderLexicon.get('location_placeholder')}
              icon={locationIcon}
              forceStacked={forceStacked}
            />
          </SearchFormBar>

          <SearchCheckbox
            value={searchTerms.filterImplant}
            setValue={(value) => updateSearchTerms({ filterImplant: value })}
            label={clinicFinderLexicon.get('implant_label')}
            forceStacked={forceStacked}
          />
          <SearchCheckbox
            value={searchTerms.filterIUD}
            setValue={(value) => updateSearchTerms({ filterIUD: value })}
            label={clinicFinderLexicon.get('iud_label')}
            forceStacked={forceStacked}
          />

          <SearchSubmitButton
            text={clinicFinderLexicon.get('submit')}
            onClick={onSearch}
            forceStacked={forceStacked}
            disabled={isSearchSubmitDisabled}
          />
        </SearchForm>
      )}
    </div>
  )
}

export default ClinicFinderForm
